export default {"src":"/_next/static/media/check.021e11e9.svg","height":14,"width":14};